import Link from 'next/link'

import { LogoSvg } from '@/shared/ui/Logo/LogoSvg'

import cl from './style.module.scss'

export const HeaderLogo = () => {
	return (
		<Link prefetch={false} href="/" aria-label="Перейти на главную страницу" className={cl.logo}>
			<LogoSvg />
		</Link>
	)
}
